module.exports = __webpack_public_path__ + "img/w-2fa.8e58d060.png";